import { DefaultValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';

/**
 * Directive for input element that converts all input characters to uppercase.
 */
@Directive({
  selector: 'input[krosToUpperCase]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => KrosToUpperCaseDirective),
    },
  ],
  standalone: false,
})
export class KrosToUpperCaseDirective extends DefaultValueAccessor {
  @HostListener('input', ['$event']) input($event: Event): void {
    const target = $event.target as HTMLInputElement;
    const start = target.selectionStart;

    target.value = target.value.toUpperCase();
    target.setSelectionRange(start, start);

    this.onChange(target.value);
  }

  constructor(renderer: Renderer2, elementRef: ElementRef) {
    super(renderer, elementRef, false);
  }
}
